const ThankYou = () => {
  return (
    <div className="flex flex-col h-screen bg-white">
      <div className="flex flex-col items-center justify-center h-full">
        <div className="space-y-4">
          <div>
            <h1 className="text-5xl text-green-600 flex items-center justify-center font-bold">
              Thank You!
            </h1>
          </div>
          <div>
            <p className="text-lg text-gray-600 font-semibold">
              Your form has been successfully submitted.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
